import { useEffect, useState } from 'react';
import styles from './sellers.module.scss';
import { SellersProps } from '../../../interfaces/components';
import { capitalize } from '../../../helpers/app';
import ProfileCard from "../../../components/ProfileCard";
import ButtonShared from '../../../components/Button/Button';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, CircularProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useToast } from '../../../helpers/hooks';
import TextFieldShared from '../../../components/TextField/TextField';
import SidebarContainer from '../../../containers/Profile/Sellers/Sidebar/SidebarContainer';
import DeleteContainer from '../../../containers/Profile/Sellers/Delete/DeleteContainer';
import { images } from '../../../constants/images';
import NoDataList from '../../../components/NoDataList/NoDataList';

const Sellers = ({
    user,
    sellers,
    getSellers,
    cleanSellers,
    branches,
    getBranches,
    cleanBranches
}: SellersProps) => {
    const toast = useToast();
    const [sidebarState, setSidebarState] = useState<any>({open: false, type: "add"});
    const [openModalDelete, setOpenModalDelete] = useState<boolean>(false);
    const [search, setSearch] = useState<string>("");
    const [sellerSelected, setSellerSelected] = useState<any>({});
    const [sellersAux, setSellersAux] = useState<any>([]);

    const handleKeyPressSearch = (value: any) => {
        let sellersFiltered = sellers?.data;
        value = value.toLowerCase();
        setSearch(value);
        if(value){
            sellersFiltered = sellers?.data && sellers?.data.filter((item: any) => item?.name.toLowerCase().includes(value) || item?.last_name.toLowerCase().includes(value)  || item?.branch?.name.toLowerCase().includes(value));
        }
        setSellersAux(sellersFiltered);
    }

    const handleClickAdd = () => {
        setSellerSelected({});
        setSidebarState({open: true, type: "add"});
    }
    
    const handleClickEdit = (item: any) => {
        setSellerSelected(item);
        setSidebarState({open: true, type: "edit"});
    }

    const handleClickDelete = (item: any) => {
        setSellerSelected(item);
        setOpenModalDelete(true);
    }

    useEffect(() => {
        if(branches?.fetching === "failure"){
            toast("Ha ocurrido un error al mostrar las sucursales");
            cleanBranches();
        }
        if(branches?.fetching === "success"){
            cleanBranches();
        }
    }, [branches?.fetching]);

    useEffect(() => {
        if(sellers?.fetching === "failure"){
            toast("Ha ocurrido un error al mostrar los vendedores");
            cleanSellers();
        }
        if(sellers?.fetching === "success"){
            setSellersAux(sellers?.data);
            handleKeyPressSearch(search);
            cleanSellers();
        }
    }, [sellers?.fetching]);

    useEffect(() => {
       
        if(user?.profile?.code !== "admin-brand") {
            if(user?.profile?.code === "admin-branch"){
                getSellers(user?.branch, "branch", "sellers");
            }else{
                getSellers(user?.dealership, "dealership", "sellers");
            }
            getBranches(user?.dealership, "branches");
        }
    }, [])

    return (
        <>
            <SidebarContainer state={sidebarState} setState={setSidebarState} sellerSelected={sellerSelected} />
            <DeleteContainer 
                open={openModalDelete} 
                setOpen={setOpenModalDelete}
                sellerSelected={sellerSelected} 
                loading={sellers?.delete?.fetching === "loading"}
            />
            {
                sellers?.fetching === "loading"
                ?
                    <div className={styles.loaderSellers} id="loaderSellers">
                        <CircularProgress 
                            size={styles.loader}
                            classes={{
                                colorPrimary: styles.loader
                            }}
                        />
                        <p>Cargando vendedores</p>
                    </div>
                :
                    (sellers?.data && sellers?.data.length === 0)
                    ?
                        <div className={styles.noData}>
                            <NoDataList
                                title="Aún no tienes vendeores"
                                text="Cuando hayas agregado un vendedor podrás ver los detalles en esta sección"
                                image={images.noSellers}
                                className={styles.message}
                            />
                            <ButtonShared
                                onPress={handleClickAdd}
                                title="Añadir"
                                icon={<AddIcon className={styles.iconButton} />}
                                primary
                            />
                        </div>
                        
                    :
                    <ProfileCard>
                        <div className={styles.sellers} id="sellersContent">
                            <div className={styles.sellersContainer}>
                                <div className={styles.header}>
                                    <ButtonShared
                                        onPress={handleClickAdd}
                                        title="Añadir"
                                        icon={<AddIcon className={styles.iconButton} />}
                                        className={`${styles.button} ${styles.add}`}
                                        primary
                                        size="small"
                                        id="addSeller"
                                    />
                                    <TextFieldShared
                                        variant="search"
                                        label="Buscar"
                                        name="nameSeller"
                                        value={search}
                                        onChange={handleKeyPressSearch}
                                        className={styles.inputSearch}
                                    />
                                </div>
                                {
                                    sellersAux && sellersAux.length === 0 && search
                                    ?
                                        <p className={styles.noDataSearch}>No se han encontrado vendedores</p>
                                    :
                                        <TableContainer className={styles.table}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow className={styles.head}>
                                                        <TableCell className={styles.cell}>Foto</TableCell>
                                                        <TableCell className={styles.cell}>Nombre y Apellido</TableCell>
                                                        <TableCell className={styles.cell}>Contacto</TableCell>
                                                        <TableCell className={styles.cell}>Sucursal</TableCell>
                                                        <TableCell className={styles.cell}>Rol</TableCell>
                                                        <TableCell className={styles.cell}>Estado</TableCell>
                                                        <TableCell className={styles.cell}></TableCell>
                                                    </TableRow>
                                                    </TableHead>
                                                <TableBody>
                                                {
                                                    sellersAux && sellersAux.map((item: any, index: number) => (
                                                        <TableRow key={index} className={styles.row}>
                                                            <TableCell className={styles.cell}>
                                                                <div className={styles.picture}>
                                                                    <img src={item?.picture ?? images.profile} alt="seller picture" className={styles.image} />
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className={styles.cell}>
                                                                <p className={`${styles.bold} ${styles.text}`}>{`${capitalize(item.name)} ${capitalize(item.last_name)}`}</p>
                                                            </TableCell>
                                                            <TableCell className={styles.cell}>
                                                                <p className={styles.text}>{item?.email}</p>
                                                            </TableCell>
                                                            <TableCell className={styles.cell}>
                                                                <p className={styles.text}>{capitalize(item?.branch?.name)}</p>
                                                            </TableCell>
                                                            <TableCell className={`${styles.cell} ${styles.role}`}>
                                                                <p className={`${styles.bold} ${styles.text}`}>
                                                                    {
                                                                        item?.profile?.name === "admin dealership"
                                                                        ?   "Administrador de concesionaria"
                                                                        :   item?.profile?.name === "admin branch"
                                                                            ?   "Administrador de sucursal"
                                                                            :   "Vendedor"
                                                                    }
                                                                </p>
                                                            </TableCell>
                                                            <TableCell className={styles.cell}>
                                                                <p className={`
                                                                    ${styles.state} 
                                                                    ${
                                                                        item?.status === "active"
                                                                        ?   styles.green
                                                                        :   item.status === "pending"
                                                                            ?   styles.blue
                                                                            :   item.status === "pause"
                                                                                ?   styles.yellow
                                                                                :   styles.red
                                                                    }
                                                                `}>
                                                                    {
                                                                        item?.status === "active"
                                                                        ?   "Activo"
                                                                        :   item.status === "pending"
                                                                            ?   "Pendiente"
                                                                            :   item.status === "pause"
                                                                                ?   "Pausado"
                                                                                :   "Inactivo"
                                                                    }
                                                                </p>
                                                            </TableCell>
                                                            <TableCell className={styles.cell}>
                                                                <div className={styles.action}>
                                                                    <IconButton onClick={() => handleClickEdit(item)} className={styles.button}>
                                                                        <EditIcon className={styles.icon} />
                                                                    </IconButton>
                                                                    <IconButton onClick={() => handleClickDelete(item)} className={styles.button}>
                                                                        <DeleteIcon className={styles.icon} />
                                                                    </IconButton>
                                                                </div>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                }
                            </div>
                        </div>
                    </ProfileCard>
            }
        </>
    )
};
export default Sellers;